// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-35w","colMin":"styles_colMin__5Yl-F"};